export default "__VITE_ASSET__45FbFmHn__"